export default __webpack_public_path__ + "static/heroSectionImage-7d2c10ed04a9415c5b95aec386cfdc3d.png";